import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Body } from 'js/design_system/Body';
import { currentUser } from 'js/utils/user';
import ChevronRightIcon from 'js/svg/colorless/chevron_right.svg';
import _Button from "ViewAllSuggestions-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/ViewAllSuggestions.tsx?styleId=Button";
import _Text from "ViewAllSuggestions-Text.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/ViewAllSuggestions.tsx?styleId=Text";
import _Container from "ViewAllSuggestions-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/ViewAllSuggestions.tsx?styleId=Container";


const Button = /*#__PURE__*/styled("div", null, {
  displayName: "Button",
  styles: _Button
});

const Text = /*#__PURE__*/styled(Body, null, {
  displayName: "Text",
  styles: _Text
});

const Container = /*#__PURE__*/styled("a", null, {
  displayName: "Container",
  styles: _Container
});

export const ViewAllSuggestions: React.FC = () => {
  return (
    <Container
      href={routes.network_new_profile_url({
        page_name: currentUser?.page_name,
        subdomain: currentUser?.domain_name,
        tab: 'suggested',
      })}
    >
      <Button>
        <ChevronRightIcon size={20} />
      </Button>
      <Text size="sm" bold>
        View all suggestions
      </Text>
    </Container>
  );
};
